import { getResource } from "./rest-helper";
import axios from "@/libs/axios";
import { handleSuccess, handleError } from "./response-handler";

const namespace = "users";
const api = {
  ...getResource(namespace),

  // Specific method for printing user password update
  updatePrintingPassword: async function (userId, password) {
    try {
      const payload = {
        password: password,
        password_confirmation: password,
      };

      const response = await axios.patch(
        `${namespace}/${userId}/printing-password`,
        payload,
      );
      return handleSuccess(
        { namespace, action: "updatePrintingPassword" },
        response,
      );
    } catch (error) {
      return handleError(
        { namespace, action: "updatePrintingPassword" },
        error.response,
      );
    }
  },
};

export { api as default };
